<template>
    <Select v-model="bindValue" @on-change="handleChange" clearable :disabled="!watchDisplay" :placeholder="attrs.placeholder || '请选择'" v-if="!attrs.multiple">
        <Option v-for="(item, i) in itemList"
            :value="String(item[attrs.valueField])"
            :key="i">
            {{ item[attrs.labelField] }}
        </Option>
    </Select>
    <Select v-model="bindValue" @on-change="handleChange" multiple :disabled="!watchDisplay" :placeholder="attrs.placeholder || '请选择'" v-else>
        <Option v-for="(item, i) in itemList"
            :value="String(item[attrs.valueField])"
            :key="i">
            {{ item[attrs.labelField] }}
        </Option>
    </Select>
</template>

<script>
    /**
     * 这里是用于配置的
     */
    import CompDisplayMixin from '@/utils/compDisplay.mixin'
    // import CompDataSpliceMixin from '@/utils/compDataSplice.mixin'
    export default {
        name: 'LySelect',
        mixins: [CompDisplayMixin],
        props: {
            value: {
                type: [String, Number, Array],
                default: ''
            },
            pageData: {
                type: Object,
                default: null
            },
            page: {
                type: Object,
                default: _ => new Object()
            }, // 所在页面的书记，目前用到是form直接传递过来，获得表单其他的状态，来改变自身状态
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        watch: {
            value: {
                handler () {
                    this.initBindValue()
                },
                immediate: true
            },
            // 页面中同样的位置，有select，不会再走created
            attrs () {
                this.initItems()
                this.initBindValue()
            }
        },
        data () {
            return {
                isFirstQuery: true, // 标识是否是第一次请求数据
                bindValue: '',
                itemList: []
            }
        },
        created () {
            this.initItems()
            // 2020.5.27添加，监听页面中的属性，然后再根据这个属性进行搜索 xq
            if (this.attrs.watchField && this.attrs.watchField.length > 0) {
                this.$watch('page.' + this.attrs.watchField, function (val) {
                    this.timer && clearTimeout(this.timer)
                    this.timer = setTimeout(() => {
                        let obj = {}
                        obj[this.attrs.watchField] = val
                        this.queryItems(obj)
                    }, 500)
                }, {
                    deep:true
                })
            }
        },
        mounted() {
            this.$eventHub.$emit(this.attrs.field + "Event", this.value)// 全局监听 modify by wxf 2018-11-13
        },
        methods: {
            /**
             * 初始化下拉选择项的数据
             */
            initItems () {
                this.$set(this, 'itemList', [])
                if ((!this.attrs.api || this.attrs.api.length < 1) && this.attrs.items.length > 0) {
                    this.$set(this, 'itemList', this.attrs.items)
                    this.resetItems()
                } else { // 有API的情况
                    this.queryItems()
                    this.resetItems()
                }
            },
            initBindValue () {
                let now = new Date().getTime()
                if (this.timer  && (now - this.timer) < 100) {
                    return
                }
                if(this.value instanceof Array){
                    this.$set(this, 'bindValue', this.value)
                }else{
                    this.$set(this, 'bindValue', String(this.value))
                }
               this.$eventHub.$emit(this.attrs.field + "Event", this.value)// 全局监听 modify by wxf 2018-11-13
            },
            /**
             * 单选项列表的获取
             */
            queryItems (params) {
                params = params || {}
                if (this.isFirstQuery) {
                    this.isFirstQuery = false
                    if (this.attrs.watchField && this.attrs.watchField.length > 0) {
                        let watchValue = this.page[this.attrs.watchField]
                        if (watchValue && String(watchValue).length > 0) {
                            params[this.attrs.watchField] = watchValue
                        }
                    }
                }
                let api = this.attrs.api
                // 有data字段说明是表格中传递过来的
                if (this.pageData) {
                    api = this.$path.getPath(api, this.pageData)
                }
                this.$api.query(api, params).then((rs) => {
                    this.$set(this, 'itemList', rs)
                    this.isChangeFirst()
                }).catch((err) => {
                    console.log('select err:%O', err)
                })
            },
            /**
             * 是否默认选中第一个值
             */
            isChangeFirst () {
                if (this.attrs.isFirst) {
                    this.bindValue = this.itemList[0][this.attrs.valueField]
                    this.handleChange(this.bindValue)
                }
            },
            handleChange (val) {
                this.timer = new Date().getTime()
                // 转换为数字类型
                if(Number(val) > 0) {
                    val = Number(val)
                }
                // 2021.2.23 xq 多选状态下，一个值得情况依然数组类型
                if(this.attrs.multiple && !(val instanceof Array)){
                    val = val.toString().split(" ")
                }
                this.$emit('input', val)
                this.$eventHub.$emit(this.attrs.field + "Event", val)// 全局监听 modify by wxf 2018-11-13
            },
            /**
             * 重置列表数据
             * create by wxf
             * time 2019-11-14
             * 如果要从account里获取，必须将account设置为true
             * 逻辑判断暂时只有 > 、< 、!=、==
             */
            resetItems () {
                if(this.attrs.hasOwnProperty("displayField") && this.attrs.displayField.length > 0) {
                    let obj = {} //存储数据对象 两种情况 1：账户数据 2：页面表单数据
                    if(this.attrs.hasOwnProperty('account') && this.attrs.account) {
                        obj = JSON.parse(localStorage.getItem("account"))
                    } else {
                        obj = this.page
                    }
                    //截取逻辑运算符
                    let option = this.attrs.displayField.match("[><!]=?|==")
                    let arr = this.attrs.items, compareField = null, list = []
                    //根据关系运算 判断
                    if(option) {
                        compareField = this.attrs.displayField.split(option[0])[1]
                        switch(option[0]) {
                            case '>':
                                arr.forEach((item, index) => {
                                    if(item.value > obj[compareField]) {
                                        list.push(item)
                                    }
                                })
                                break;
                            case '<':
                                arr.forEach((item, index) => {
                                    if(item.value < obj[compareField]) {
                                        list.push(item)
                                    }
                                })
                                break;
                            case '==':
                                arr.forEach((item, index) => {
                                    if(item.value == obj[compareField]) {
                                        list.push(item)
                                    }
                                })
                                break;
                            case '!=':
                                arr.forEach((item, index) => {
                                    if(item.value != obj[compareField]) {
                                        list.push(item)
                                    }
                                })
                                break;
                            default:
                                list = []
                        }
                        this.$set(this, 'itemList', list)
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/select/src/index.vue